var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowCarousel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 46.5685 13.4315 60 30 60H60L60 0H30C13.4315 0 0 13.4315 0 30Z",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23L34 30L27 37",
    stroke: "#737478",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowCarousel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowCarousel.30a6b9407c701c5fd3edc925e20d7325.svg";